export const setSvgAttribute = ({
	svg,
	attributeName,
	attributeValue,
}: {
	svg: string
	attributeName: string
	attributeValue: string | number
}): string => {
	const svgTagMatch = svg.match(/^<svg\b[^>]*>/)

	if (!svgTagMatch) return svg

	const originalTag = svgTagMatch[0]
	const attributeRegex = new RegExp(`\\s${attributeName}="[^"]*"`)

	// Check if the attribute exists and replace it, otherwise create it
	const updatedTag = attributeRegex.test(originalTag)
		? originalTag.replace(
				attributeRegex,
				` ${attributeName}="${attributeValue}"`,
			)
		: originalTag.replace('<svg', `<svg ${attributeName}="${attributeValue}"`)

	return svg.replace(originalTag, updatedTag)
}
